import { ArgsType, Field } from '@nestjs/graphql'

@ArgsType()
export class GetCouponArgs {
  @Field({ nullable: true })
  forFp?: boolean

  @Field({ nullable: true })
  cycle?: string

  @Field({ nullable: true })
  plan?: string
}
